import React from "react";
import { Link } from "react-router-dom";

function NavBarList() {
  return (
    <div>
      <div className="NavBarListDetails">
        <div>
          <div className="NavBarWrapper">
            <div className="NavList1">
              <Link to="/" className="CleeQ__Link">
                <div className="ClickLink">Home</div>
              </Link>

              <Link to="/Membership" className="CleeQ__Link">
                <div className="ClickLink">Membership</div>
              </Link>

              <Link to="/Excos" className="CleeQ__Link">
                <div className="ClickLink">Excos</div>
              </Link>
              <Link to="/Projects" className="CleeQ__Link">
                <div className="ClickLink">Projects</div>
              </Link>
              <Link to="/News" className="CleeQ__Link">
                <div className="ClickLink">News</div>
              </Link>
              <Link to="/Events" className="CleeQ__Link">
                <div className="ClickLink">Events</div>
              </Link>
              <Link to="/AboutUs" className="CleeQ__Link">
                <div className="ClickLink"> About us</div>
              </Link>
              <Link to="/Gallery" className="CleeQ__Link">
                <div className="ClickLink"> Photo Gallery</div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NavBarList;
